module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/store_images/4@2x_e4d164ffd66cd76955e8dc8356586d76.png";